import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createCrisisPopup = async (data) => {

  try {
    let res = await Api.post("/crisis-popup", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getCrisisPopup = async (query) => {
  try {
    let res = await Api.get("/crisis-popup", {
      params: query,
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};



export const deleteCrisisPopup = async (id) => {
  try {
    let res = await Api.delete("/crisis-popup/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateCrisisPopup = async (id, data) => {
  try {
    let res = await Api.patch("/crisis-popup/" + id, data);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

